import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);
const KEY = "kl_region";

export function RegionProvider({ children }) {
  const [regions, setRegions] = useState([]);
  const [fx, setFx] = useState(null);
  const [active, setActiveState] = useState(localStorage.getItem(KEY) || "ALL");

  const loadRegions = useCallback(() => api.get("/regions").then((r) => setRegions(r.data)).catch(() => {}), []);
  const loadFx = useCallback((refresh = false) => api.get("/fx", { params: refresh ? { refresh: true } : {} }).then((r) => setFx(r.data)).catch(() => {}), []);

  useEffect(() => { loadRegions(); loadFx(); const t = setInterval(() => loadFx(), 15 * 60 * 1000); return () => clearInterval(t); }, [loadRegions, loadFx]);

  const setActive = (code) => { localStorage.setItem(KEY, code); setActiveState(code); };
  const byCode = useMemo(() => Object.fromEntries(regions.map((r) => [r.code, r])), [regions]);

  const convert = useCallback((amount, from, to) => {
    if (amount == null || !fx?.rates || from === to) return amount;
    if (!fx.rates[from] || !fx.rates[to]) return null;
    return (amount / fx.rates[from]) * fx.rates[to];
  }, [fx]);

  const rate = useCallback((from, to) => convert(1, from, to), [convert]);

  return <Ctx.Provider value={{ regions, byCode, active, setActive, fx, convert, rate, reloadRegions: loadRegions, refreshFx: () => loadFx(true) }}>{children}</Ctx.Provider>;
}

export const useRegion = () => useContext(Ctx);
